import { render, staticRenderFns } from "./UserLeaves.vue?vue&type=template&id=7bc540ca&scoped=true&"
import script from "./UserLeaves.vue?vue&type=script&lang=js&"
export * from "./UserLeaves.vue?vue&type=script&lang=js&"
import style0 from "./UserLeaves.vue?vue&type=style&index=0&id=7bc540ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc540ca",
  null
  
)

export default component.exports